'use client';
import { FC, useState } from 'react';
import  SwipeableDrawer from '@/components/shared/bottom-sheet/bottom-sheet.component';
import Modal from '@/components/shared/modal.component';
import  Button  from '@/components/shared/Button/button.component';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation, useWindowDimensions } from '@/hook';
import { HelpOutline } from '@mui/icons-material';
import WhatsIncludedPopUp from './whats-included-popup-content.component';
import colors from '@/theme/colors.module.scss';
import { Tick } from '../../../../public/Images';
import Image from 'next/image';
import styles from './styles.module.scss';

const WhatsIncluded: FC<{
  hideText?: boolean;
  hideButton?: boolean;
  hideIcon?: boolean;
  hideToolTip?: boolean;
  registrationFees?: number | null;
}> = ({
  hideToolTip = false,
  hideText = false,
  hideButton = false,
  hideIcon = false,
  registrationFees,
}) => {
  const { t, i18n, IS_RTL } = useTranslation();
  const [openWhatsIncludedModal, setOpenWhatsIncludedModal] = useState(false);
  const { width, IS_DESKTOP } = useWindowDimensions();
  return (
    <>
      <div className={styles.container}>
        {!hideIcon && <Image src={Tick} width={16} height={16} alt="check-box" />}
        <div
          className={`${styles.containerInner} ${styles.btn}`}
          onClick={() => {
            setOpenWhatsIncludedModal(true);
          }}
        >
          <div className={styles.containerInnerText}>
            {!hideText && (
              <Typography color={colors.gray600} variant="captionMedium">
                {t('whatsIncluded.outerText')}
              </Typography>
            )}
            {!hideButton && (
              <div className={styles.viewMoreContainer}>
                <Typography
                  color={colors.primary700}
                  className={styles.viewBenefits}
                  variant="captionSemiBold"
                >
                  {t('whatsIncluded.outerTextButton')}
                </Typography>
                {!hideToolTip && (
                  <HelpOutline
                    sx={{
                      color: colors.primary700,
                      width: '16px',
                      height: '16px',
                      transform: IS_RTL ? 'scaleX(-1)' : '',
                    }}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {IS_DESKTOP ? (
        <Modal
          open={openWhatsIncludedModal}
          setOpen={setOpenWhatsIncludedModal}
          sx={{
            backdropFilter: 'blur(6px)',
            borderRadius: '12px',
            padding: '24px',
          }}
        >
          <WhatsIncludedPopUp
            open={openWhatsIncludedModal}
            setOpen={setOpenWhatsIncludedModal}
            registrationFees={registrationFees}
          />
        </Modal>
      ) : (
        <SwipeableDrawer open={openWhatsIncludedModal} setOpen={setOpenWhatsIncludedModal}>
          <div className={styles.mobileContainer}>
            <WhatsIncludedPopUp
              open={openWhatsIncludedModal}
              setOpen={setOpenWhatsIncludedModal}
              registrationFees={registrationFees}
            />
            <div className={styles.mobileBottom}>
              <Button onClick={() => setOpenWhatsIncludedModal(false)}>
                <Typography variant="body1Medium">{t('Continue')}</Typography>
              </Button>
            </div>
          </div>
        </SwipeableDrawer>
      )}
    </>
  );
};

export default WhatsIncluded;
